// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"743":"eaad0586","835":"2a43ff97"}[chunkId] + ".chunk.js";
};